<template>
	<div class="map-current">
		<div class="map-current__title">{{ point.name }}</div>
		<address
			class="map-current__address"
			@click="handleAddressClick"
		>{{ point.address }}<br v-if="point.metro">{{ point.metro || '' }}</address>
		<div
			v-for="(contact, id) in point.contacts"
			:key="id"
			class="map-current-box">
			<div class="map-current-box__title">{{ contact.name }}</div>
			<a
				v-if="contact.type === 'tel'"
				:href="getPhoneHref(contact.value)" class="map-current-box__value"
			>
				{{ contact.value }}
			</a>
			<a
				v-else-if="contact.type === 'email'"
				:href="`mailto:${contact.value}`" class="map-current-box__value"
			>
				{{ contact.value }}
			</a>
			<div v-else class="map-current-box__value" v-html="contact.value"></div>
		</div>
		<button
			type="button"
			class="map-current__close"
			@click="emit('close')"
		></button>
	</div>
</template>

<script setup lang="ts">
import { writeClipboard } from '@/shared/helpers/helpers';

defineProps({
	point: {
		type: Object,
		required: true,
	},
});

const emit = defineEmits(['close']);

const getPhoneHref = (phone: string) => `tel:${phone.replace(/[-() ]/g, '')}`;

const handleAddressClick = (event: MouseEvent) => {
	const addressElement = event.currentTarget as HTMLElement;
	const text = addressElement.innerText.trim();
	writeClipboard(text);
};
</script>
